import { combineReducers } from 'redux';
import invitee from './reducers/invitee';
import title from './reducers/title';
import styles from './reducers/styles';
import admin from './reducers/admin';
import dates from './reducers/dates';
import invitation from './reducers/invitation';
import photos from './reducers/photos';

export default combineReducers({
  invitation,
  invitee,
  styles,
  title,
  admin,
  dates,
  photos,
});



// WEBPACK FOOTER //
// ./src/Reducer.js